
import DashboardAssessmentCard, {
  AssessmentCardType
} from "@/components/candidate/DashboardAssessmentCard.vue";
import HelloUser from "@/components/shared/HelloUser.vue";
import { AppAssessments } from "@/interfaces/data_objects/app_assessments";
import {
  GET_COMPANY_DETAILS,
  GET_USER_DETAILS,
  UPDATE_USER_DETAILS
} from "@/store/modules/auth/constants";
import { CHECK_SURVEY_ALREADY_SUBMITTED } from "@/store/modules/candidates/constants";
import {
  APP_ASSESSMENTS,
  APP_ASSESSMENT_RESULT
} from "@/store/modules/common/constants";
import { REDO_ASSESSMENT_REQUEST } from "@/store/modules/recruiter/constants";
import { ROOT_NOTIFICATION } from "@/store/modules/root/constants";
import Vue from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default Vue.extend({
  name: "InceptionCandidateDashboard",
  components: {
    HelloUser,
    DashboardAssessmentCard
  },
  data() {
    return {
      dialog: {
        value: false
      },
      survey_popup: false,
      survey_already_submitted: false,
      is_both_assessment_completed: false,
      assessments: [] as AssessmentCardType[]
    };
  },
  created() {
    // this.show_intro();
  },
  async mounted() {
    this.assessments = [
      {
        status: AppAssessments.AppAssessmentStatus.IN_PROGRESS,
        is_show: true,
        type: "english",
        title: this.$t("assessments.eng-title") as string,
        description: this.$t("assessments.eng-description") as string,
        icon: require("@/assets/icons/inception_eng_assessment.svg"),
        version:
          this.get_company_details?.storage_path?.assessment_setting
            ?.candidates_english
      },
      {
        status: AppAssessments.AppAssessmentStatus.IN_PROGRESS,
        is_show: true,
        type: "annotation",
        title: this.$t("assessments.annotation-title") as string,
        description: this.$t("assessments.annotation-description") as string,
        icon: require("@/assets/icons/inception_annotation_assessment.svg"),
        version:
          this.get_company_details?.storage_path?.assessment_setting
            ?.candidates_annotation
      },
      {
        status: AppAssessments.AppAssessmentStatus.IN_PROGRESS,
        is_show: true,
        type: "ai",
        title: this.$t("assessments.ai-title") as string,
        description: this.$t("assessments.ai-description") as string,
        icon: require("@/assets/icons/inception_ai_assessments.png"),
        version: ""
      }
    ];
    this.survey_already_submitted = await this.check_survey_submitted();
    if (this.survey_already_submitted) {
      this.survey_popup = false;
    } else {
      this.survey_popup = this.is_both_assessment_completed;
    }
    localStorage.removeItem("stage");
    localStorage.removeItem("partTime");
    localStorage.removeItem("partsTime");
    localStorage.removeItem("questionTime");
    localStorage.removeItem("englishAssessmentTimer");
    localStorage.removeItem("question_id");
    localStorage.removeItem("answers");
    localStorage.removeItem("assessmentTime");
    localStorage.removeItem("assessment_cancelled");
    localStorage.removeItem("eng-terms-accepted");
  },
  watch: {
    assessments: {
      handler: async function (newAssessments: AssessmentCardType[]) {
        const engAssessment = newAssessments.find(
          (assessment) => assessment.type === "english"
        );
        const annAssessment = newAssessments.find(
          (assessment) => assessment.type === "annotation"
        );

        if (
          engAssessment &&
          annAssessment &&
          engAssessment.status ===
            AppAssessments.AppAssessmentStatus.COMPLETED &&
          annAssessment.status === AppAssessments.AppAssessmentStatus.COMPLETED
        ) {
          this.is_both_assessment_completed = true;
          if (!this.survey_already_submitted) {
            this.survey_popup = true;
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  // async beforeRouteLeave(to, from, next) {
  // const thisself = this;
  // console.log("f2 leave");
  // Convert `this.response` to a string before storing it
  // localStorage.setItem("leaving_stage", this.response);
  // console.log("Saved response to localStorage");
  // next();
  // },
  computed: {
    ...mapGetters("auth", {
      get_user_details: GET_USER_DETAILS
    }),
    ...mapGetters("common", {
      app_assessments: APP_ASSESSMENTS
    }),
    ...mapGetters("auth", {
      get_company_details: GET_COMPANY_DETAILS
    })
  },
  methods: {
    ...mapActions("common", {
      app_assessment_result: APP_ASSESSMENT_RESULT
    }),
    ...mapActions("auth", {
      update_user_details: UPDATE_USER_DETAILS
    }),
    ...mapActions("recruiter", {
      redo_assessment_request: REDO_ASSESSMENT_REQUEST
    }),
    ...mapMutations({
      set_root_notification: ROOT_NOTIFICATION
    }),
    ...mapActions("candidate", {
      check_survey_submitted: CHECK_SURVEY_ALREADY_SUBMITTED
    }),

    async navigateToIntro() {
      this.dialog.value = false;
      // User Data
      let user_data = {
        ...this.get_user_details.user_data,
        is_intro_showed: true
      };

      // const response =
      await this.update_user_details({ user_data });
      // if (response) {
      //   this.set_root_notification("Data Upload Successfully");
      // }

      this.$router.push({ name: "dashboard-intro" });
    },
    show_intro() {
      if (
        this.get_user_details.user_data &&
        this.get_user_details.user_data.is_intro_showed
      ) {
        this.dialog.value = false;
      } else this.dialog.value = true;
    }
  }
});
